<script setup>
defineProps({
  title: { type: String, default: 'Over VSB Verhuur' },
  intro: { type: String, default: '' },
  hours: { type: Array, default: () => [] },
  locations: { type: Array, default: () => [] }
});
</script>

<template>
  <div class="vsb-footer__column">
    <h3 class="vsb-footer__heading">{{ title }}</h3>
    <p v-if="intro" class="vsb-footer__intro">{{ intro }}</p>

    <h4 class="vsb-footer__subheading">Openingstijden</h4>
    <ul class="vsb-footer__hours">
      <li v-for="(row, index) in hours" :key="`hour-${index}`">
        <strong>{{ row.label }}</strong> {{ row.value }}
      </li>
    </ul>

    <h4 class="vsb-footer__subheading">Locaties</h4>
    <ul class="vsb-footer__locations">
      <li v-for="(row, index) in locations" :key="`loc-${index}`">
        <strong>{{ row.name }}</strong> – {{ row.detail }}
      </li>
    </ul>
  </div>
</template>
